

const size = {
    galaxyFold: '512px',
    surfaceDuo: '540px',
    iPadPro: '1024px',
    iPad: '768px',
    iPadAir: '820px',
    iPhoneX: '375px',
    iPhone678Plus: '414px',
    iPhone12Pro: '390px',
    pixel2XL: '411px',
    samsungGalaxyS20Ultra: '412px',
    galaxyS5: '360px',
    
    
  }


export const device = {
    galaxyFold: `(max-width: ${size.galaxyFold})`,
    surfaceDuo: `(max-width: ${size.surfaceDuo})`,
    iPadPro: `(max-width: ${size.iPadPro})`,
    iPad: `(max-width: ${size.iPad})`,
    iPadAir: `(max-width: ${size.iPadAir})`,
    iPhoneX: `(max-width: ${size.iPhoneX})`,
    iPhone678Plus: `(max-width: ${size.iPhone678Plus})`,
    iPhone678: `(max-width: ${size.iPhone678})`,
    iPhone12Pro: `(max-width: ${size.iPhone12Pro})`,
    pixel2XL: `(max-width: ${size.pixel2XL})`,
    samsungGalaxyS20Ultra: `(max-width: ${size.samsungGalaxyS20Ultra})`,
    galaxyS5: `(max-width: ${size.galaxyS5})`

  };


